export default __webpack_public_path__ + "static/media/MET-REA.4c94569c.png";